import { AutogenModelCarrierDriverContacts, AutogenRowCarrierDriverContacts } from "./autogen/AutogenModelCarrierDriverContacts";

export class ModelCarrierDriverContacts extends AutogenModelCarrierDriverContacts<RowCarrierDriverContacts> {
	constructor() {
		super(RowCarrierDriverContacts);
	}
}

export class RowCarrierDriverContacts extends AutogenRowCarrierDriverContacts {
}